import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { toast } from "sonner";

export default function AuditLogPage() {
  const [items, setItems] = useState([]);
  const [action, setAction] = useState("");

  const load = async () => {
    try {
      const params = {};
      if (action) params.action = action;
      const { data } = await api.get("/audit", { params });
      setItems(data);
    } catch (e) { toast.error(formatApiError(e)); }
  };
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [action]);

  const toneFor = (a) => {
    if (a.includes("fail") || a.includes("locked")) return "text-red-700 border-red-200 bg-red-50";
    if (a.includes("success") || a.includes("created")) return "text-emerald-700 border-emerald-200 bg-emerald-50";
    if (a.includes("updated") || a.includes("changed")) return "text-blue-700 border-blue-200 bg-blue-50";
    return "text-muted-foreground";
  };

  return (
    <div className="space-y-6" data-testid="audit-log-page">
      <div className="flex items-end justify-between flex-wrap gap-3">
        <div>
          <div className="tiny-label">Compliance</div>
          <h1 className="font-display text-4xl font-bold tracking-tight mt-2">Audit log</h1>
          <p className="text-muted-foreground mt-1">Immutable record of logins, edits, approvals, and settings changes.</p>
        </div>
        <div>
          <Label>Filter by action</Label>
          <Input placeholder="e.g. auth.login" className="w-64" value={action} onChange={(e) => setAction(e.target.value)} data-testid="audit-filter-action" />
        </div>
      </div>

      <Card className="border-border shadow-none">
        <div className="overflow-x-auto app-scroll">
          <table className="w-full text-sm">
            <thead className="bg-muted/50">
              <tr className="text-left tiny-label">
                <th className="px-4 py-3">Time</th>
                <th className="px-4 py-3">Actor</th>
                <th className="px-4 py-3">Action</th>
                <th className="px-4 py-3">Target</th>
                <th className="px-4 py-3">IP</th>
                <th className="px-4 py-3">Meta</th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.id} className="border-t border-border">
                  <td className="px-4 py-3 text-xs font-mono">{new Date(i.created_at).toLocaleString()}</td>
                  <td className="px-4 py-3">{i.actor_email || "—"}</td>
                  <td className="px-4 py-3"><Badge variant="outline" className={toneFor(i.action)}>{i.action}</Badge></td>
                  <td className="px-4 py-3 font-mono text-xs">{i.target || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs">{i.ip || "—"}</td>
                  <td className="px-4 py-3 text-xs text-muted-foreground max-w-md truncate">{i.meta ? JSON.stringify(i.meta) : ""}</td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-muted-foreground">No events.</td></tr>}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
